import { Reducer } from 'redux'
import { IExternalCourseParticipantsState } from 'store/states/externalCourseParticipant.state'
import { IExternalCourseParticipant } from 'models/externalCourseParticipant.model'
import * as fromActions from '../actions/externalCourseParticipant.action'

export const initialState: IExternalCourseParticipantsState = {
  list: [],
  total: 0,
  perPage: 0,
  sort: [],
  loading: true,
  externalCourse: { loading: false },
}

type AdministrationListSuccess = {
  type: typeof fromActions.EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST_SUCCESS
  payload: {
    data: IExternalCourseParticipant[]
    total: number
    perPage: number
    sort: any[]
  }
}

type Loading = {
  type:
    | typeof fromActions.EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST
    | typeof fromActions.DESTROY_EXTERNAL_COURSE_PARTICIPANT
    | typeof fromActions.EXTERNAL_COURSE_PARTICIPANTS_LOADING
  payload: {
    loading: boolean
  }
}

type Empty = {
  type: typeof fromActions.DESTROY_EXTERNAL_COURSE_PARTICIPANTS
  payload: void
}

export type ReducerActions = AdministrationListSuccess | Loading | Empty

export const reducer: Reducer<
  IExternalCourseParticipantsState,
  ReducerActions
> = (
  state: IExternalCourseParticipantsState = initialState,
  action
): IExternalCourseParticipantsState => {
  switch (action.type) {
    case fromActions.EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST_SUCCESS: {
      const { data, total, perPage, sort } = action.payload
      return {
        ...state,
        list: data,
        total,
        perPage,
        sort,
        loading: false,
      }
    }

    case fromActions.EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST:
    case fromActions.DESTROY_EXTERNAL_COURSE_PARTICIPANT:
      return {
        ...state,
        loading: true,
      }
    case fromActions.EXTERNAL_COURSE_PARTICIPANTS_LOADING: {
      const { loading } = action.payload
      return {
        ...state,
        loading,
      }
    }
    default:
      return state
  }
}
